const config = {
  environment: 'qa',
  redirect_url: 'https://qa.hotglue.xyz/callback',
  api_url: 'https://qa-client-api.hotglue.xyz',

};

export default config;
